import { CheckCircle, Drop, Ruler, Shovel } from '@phosphor-icons/react';
import { Breadcrumbs } from '../components/Breadcrumbs';
import { Callout } from '../components/Callout';
import { Reveal } from '../components/Reveal';
import { ServiceCard } from '../components/ServiceCard';
import { services } from '../content/site';
import { getPrimaryServices } from '../lib/serviceDisplay';

export function Services() {
  const primaryServices = getPrimaryServices(services);

  return (
    <>
      <section className="page-hero section-shell">
        <Breadcrumbs items={[{ label: 'Services' }]} />
        <div className="page-hero__grid">
          <Reveal>
            <p className="section-kicker">Hardscapes, masonry, and tile</p>
            <h1>Build something useful. Make it look right.</h1>
          </Reveal>
          <Reveal delay={0.08}><p className="page-hero__lede">Explore new installations and repairs in pavers, brick, block, tile, concrete, faux stone, drainage, and grading.</p></Reveal>
        </div>
      </section>

      <section className="service-index section-pad section-shell">
        {primaryServices.map((service, index) => (
          <Reveal key={service.slug} delay={Math.min(index * 0.045, 0.2)}>
            <ServiceCard
              service={service}
              image
              imageSizes="(max-width: 767px) calc(100vw - 24px), min(48vw, 650px)"
            />
          </Reveal>
        ))}
      </section>

      <section className="scope-section section-pad section-shell">
        <Reveal className="section-heading"><h2>A useful scope answers four questions.</h2></Reveal>
        <div className="scope-grid">
          <Reveal><Ruler aria-hidden="true" size={27} /><h3>What carries the load?</h3><p>People, vehicles, retained soil, structures, and weather all change the work.</p></Reveal>
          <Reveal delay={0.05}><Drop aria-hidden="true" size={27} /><h3>Where does water move?</h3><p>Runoff and subsurface water need a safe path before finishes are selected.</p></Reveal>
          <Reveal delay={0.1}><Shovel aria-hidden="true" size={27} /><h3>What is below the surface?</h3><p>Base, soil, existing construction, and access affect preparation and repair.</p></Reveal>
          <Reveal delay={0.15}><CheckCircle aria-hidden="true" size={27} /><h3>What does finished mean?</h3><p>Material, color, joint, edge, cleanup, and use timing belong in the written scope.</p></Reveal>
        </div>
      </section>

      <Callout title="Not sure which service fits?" text="Describe what you see and where it is happening. We can start with the problem, not the category." />
    </>
  );
}
